import React from 'react'
import Video from '../Video'
import styled from 'styled-components'

const FullVideo = styled.div`
    width: 100%;
`

const FullwidthVideo = ({videoURL, altText, poster}) => {
    return (
        <FullVideo className="row-component">
            { <Video videoURL = {videoURL} altText={altText} poster={poster} /> }
        </FullVideo>
    )
}

export default FullwidthVideo
